import { render, staticRenderFns } from "./ZoomCanvas.vue?vue&type=template&id=01797efe&scoped=true&"
import script from "./ZoomCanvas.vue?vue&type=script&lang=js&"
export * from "./ZoomCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01797efe",
  null
  
)

export default component.exports